module.exports = __webpack_public_path__ + "img/account_100.957f82cd.jpg";